import React, { useState, useEffect } from 'react';
import { ref, get, update } from 'firebase/database';
import { db } from './firebase';
import { formatCourseId } from './utils/formatCourse';

const AdminStudents = () => {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStudents();
    }, []);

    const fetchStudents = async () => {
        try {
            const coursesRef = ref(db, 'courses');
            const snapshot = await get(coursesRef);

            if (snapshot.exists()) {
                const courses = snapshot.val();
                const allStudents = [];

                // Iterate through each course
                Object.entries(courses).forEach(([courseId, courseData]) => {
                    if (courseData.students) {
                        // Add each student with their course information
                        Object.entries(courseData.students).forEach(([studentId, studentData]) => {
                            allStudents.push({
                                ...studentData,
                                courseId,
                                studentId,
                            });
                        });
                    }
                });

                setStudents(allStudents);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching students:', error);
            setLoading(false);
        }
    };

    const toggleLoginStatus = async (courseId, studentId, currentStatus) => {
        try {
            const studentRef = ref(db, `courses/${courseId}/students/${studentId}`);
            await update(studentRef, {
                isLoggedIn: !currentStatus
            });

            // Update local state
            setStudents(students.map(student =>
                student.courseId === courseId && student.studentId === studentId
                    ? { ...student, isLoggedIn: !currentStatus }
                    : student
            ));
        } catch (error) {
            console.error('Error updating login status:', error);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-teal-500"></div>
            </div>
        );
    }

    return (
        <div className="p-6 bg-white">
            <h1 className="text-2xl font-bold mb-6 text-gray-900">Student Login Management</h1>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-gray-50">
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Course</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {students.map((student) => (
                                <tr key={`${student.courseId}-${student.studentId}`} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-gray-900">{student.name}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-gray-900">{student.email}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-gray-900">{formatCourseId(student.courseId)}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${student.isLoggedIn
                                            ? 'bg-green-100 text-green-800'
                                            : 'bg-red-100 text-red-800'
                                            }`}>
                                            {student.isLoggedIn ? 'Online' : 'Offline'}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <button
                                            onClick={() => toggleLoginStatus(student.courseId, student.studentId, student.isLoggedIn)}
                                            className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${student.isLoggedIn
                                                ? 'bg-red-100 text-red-800 hover:bg-red-200'
                                                : 'bg-green-100 text-green-800 hover:bg-green-200'
                                                }`}
                                        >
                                            {student.isLoggedIn ? 'Set Offline' : 'Set Online'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AdminStudents; 